import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, TableBody, TableCell, TableRow, withStyles } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import { notArrayOrEmpty } from '../../utils/helpers';
import NoData from './../Common/NoDataRow';
import guid from './../../utils/guid';
import { displayDateTimeFormat } from './../../utils/staticData';
import moment from 'moment-timezone';
import t from "../../languages/pl";

const useStyles = theme => ({
    cell: {
        padding: theme.spacing(1)
    }
});

const getUserTypeLabel = (type) => {
  switch (type) {
    case 'podadmin':
      return 'Administrator';
    case 'tymczasowy':
      return 'Tymczasowy';
    default:
      return 'Podstawowy';
  }
};

const TableContent = props => {
    const { classes, users, onUserDetailsClick } = props;

    const printTable = data => {
        if (notArrayOrEmpty(data))
            return <NoData colSpan={5} />;
        return data.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell
                        align="center"
                        className={classes.cell}
                    >
                        {row.uzytkownik_email}
                    </TableCell>
                    <TableCell
                        align="center"
                        className={classes.cell}
                    >
                        {row.uzytkownik_login}
                    </TableCell>
                  <TableCell
                    align="center"
                    className={classes.cell}
                  >
                    {getUserTypeLabel(row.uzytkownik_typ)}
                  </TableCell>
                    <TableCell
                        align="center"
                        className={classes.cell}
                    >
                        {row.liczba_aut}
                    </TableCell>
                    <TableCell
                        align="center"
                        className={classes.cell}
                    >
                        {row.ost_aktywnosc === -1 ? t.noActivity : moment.unix(row.ost_aktywnosc).format(displayDateTimeFormat)}
                    </TableCell>
                    <TableCell
                        align="center"
                        className={classes.cell}
                    >
                        <IconButton
                            onClick={() => onUserDetailsClick(row.uzytkownik_id)}
                        >
                            <ListIcon />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableBody>
            {printTable(users)}
        </TableBody>
    );
};

TableContent.propTypes = {
    classes: PropTypes.object,
    users: PropTypes.array,
    onUserDetailsClick: PropTypes.func
};

export default withStyles(useStyles)(TableContent);
